class Tabs {

	constructor(elem) {
		this.tabs = elem;
	}

	initialize() {
		let tabsHead = $('[data-tabs-head]');
		let tabsSelect = $('[data-tabs-select]');

		tabsHead.each(function() {
			let el = $(this);

			let tabsLink = el.children();
			let tabsBody = el.closest('[data-tabs]').children('[data-tabs-body]');
			let tabsItem = tabsBody.children();

			tabsLink.click(function(e) {
				let el = $(this);
				let index = el.index();

				tabsLink.removeClass('active');
				el.addClass('active');

				tabsItem.removeClass('active');
				tabsItem.eq(index).addClass('active');

				if (tabsSelect.length > 0) {
					tabsSelect.children().eq(index).prop('selected', true);
				}

				e.preventDefault();
			});
		});

		tabsSelect.on('change', function() {
			let el = $(this);
			let index = el.val();
			let tabsBody = el.closest('[data-tabs]').children('[data-tabs-body]');
			let tabsItem = tabsBody.children();
			let tabsHead = el.closest('[data-tabs]').children('[data-tabs-head]');
			let tabsLink = tabsHead.children();

			tabsLink.removeClass('active');
			tabsLink.eq(index).addClass('active');

			tabsItem.removeClass('active');
			tabsItem.eq(index).addClass('active');
		});
	}

    reInit() {
        if ($('[data-tabs-head]').length > 0) {
            $('[data-tabs-head]').each(function(i) {
                let tabs = new Tabs($(this));
                tabs.initialize();
            });
        }
    }
}

$(window).on('load', () => {
	let tabs = [];

	if ($('[data-tabs-head]').length > 0) {
		$('[data-tabs-head]').each(function(i) {
			tabs[i] = new Tabs($(this));
			tabs[i].initialize();
		});
	}

    window.Tabs = new Tabs();
});
